import Program from "wwg-utilities/dist/collections/program";
import GetStartedButton from "../GetStartedButton";

interface ApplyingProps {
    program: Program;
}

const Applying: React.FC<ApplyingProps> = ({ program }) => {
    return (
        <section className={`bg-sidebar rounded-lg p-6 md:p-10 my-4`}>
            <div className="flex flex-col items-start">
                <figure className="flex flex-start">
                    <img
                        className="w-8 h-8"
                        src="https://res.cloudinary.com/wherewego/image/upload/v1652490778/project-connect/in9vn8pazfikdnwxynwp.svg"
                        alt="Exclamation Icon"
                    />

                    <div className={`flex flex-col text-sidebar-text`}>
                        {/* {Boolean(
                        isSkillup &&
                          program.applicationData?.applicationComment,
                      ) && (
                        <figcaption className="mb-10 ml-4 text-lg leading-6 font-base">
                          {program.applicationData?.applicationComment}
                        </figcaption>
                      )} */}
                        {program.applicationData?.nextStepsComment && (
                            <figcaption className="ml-4 text-lg leading-6 font-base">
                                {program.applicationData?.nextStepsComment}
                            </figcaption>
                        )}
                    </div>
                </figure>
            </div>
            <div className="mx-auto w-[200px] mt-10">
                <GetStartedButton location="bottom" program={program} />
            </div>
        </section>
    );
};

export default Applying;